import {useContext} from "react"
import { LogsContext } from "./context"

export function useLogsHook() {
    return useContext(LogsContext)
}